import * as React from 'react';

const It16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#009246", d: "M1 5a2 2 0 0 1 2-2h2.667v10H3a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M5.667 3h4.667v10H5.667z" }), /* @__PURE__ */ React.createElement("path", { fill: "#CE2B37", d: "M10.334 3H13a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2.666z" }));
It16.Size = 16;
It16.Title = "It";

export { It16 as default };
